import { useCallback } from "react";
import { gql, useMutation } from "@apollo/client";

const UpdateLatestTeacherCoordinatorReviewMutation = gql`
  mutation updateLatestTeacherCoordinatorReview(
    $teacherId: String!
    $fluencyScore: Int!
    $presenceScore: Int!
    $clarityScore: Int!
  ) {
    updateLatestTeacherCoordinatorReview(
      teacherId: $teacherId
      fluencyScore: $fluencyScore
      presenceScore: $presenceScore
      clarityScore: $clarityScore
    ) {
      id
      teacherId
      reviewedAtUtc
      scores {
        fluencyScore
        presenceScore
        clarityScore
      }
    }
  }
`;

export function useUpdateLatestTeacherCoordinatorReview() {
  const [mutate, { loading }] = useMutation(
    UpdateLatestTeacherCoordinatorReviewMutation,
  );

  const updateReview = useCallback(
    async (input: {
      teacherId: string;
      fluencyScore: number;
      presenceScore: number;
      clarityScore: number;
    }) => {
      await mutate({ variables: input });
    },
    [mutate],
  );

  return { updateReview, loading };
}
